import React, { useEffect, useState } from "react";
import { useAuthUser } from 'react-auth-kit';
import axios from "../api/axios";
import { useAuthHeader } from "react-auth-kit";
import Navbarespaceperso from "../components/Navbarespaceperso";
import { useNavigate } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { Box, Typography, Button, TextField, List, ListItem, ListItemText, ListItemIcon, createTheme, ThemeProvider } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import PaymentIcon from '@mui/icons-material/Payment';
import { borderRadius } from "@mui/system";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const theme = createTheme({
  palette: {
    primary: {
      main: '#96013C',
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#f5f5f5',
            '& fieldset': {
              borderColor: '#96013C',
            },
            '&:hover fieldset': {
              borderColor: '#96013C',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#96013C',
            },
          },
          '& .MuiInputLabel-root': {
            color: '#000',
            fontWeight: 'bold',
          },
        },
      },
    },
  },
});

function Espace_Perso() {
  const authUser = useAuthUser();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [equipes, setEquipes] = useState([]);
  const [open, setOpen] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("success");
  const [id, setId] = useState(authUser().id);
  const [showForm, setShowForm] = useState(false);
  const [telephone, setTelephone] = useState("");
  const [email, setEmail] = useState("");
  const [payement, setPayement] = useState(0);
  const [activeSection, setActiveSection] = useState('profile');
  const authHeader = useAuthHeader();

  const config = { headers: { Authorization: authHeader() } };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`/equipe/getTeams?id=${id}`, config);
        setEquipes(response.data.team);
        setPayement(response.data.team[0].payement);
        setLoading(false);
      } catch (error) {
        console.error("Erreur lors de la récupération des équipes:", error);
      }
    };

    fetchData();
  }, []);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handlePayement = () => {
    const collecteURL = 'https://collecte.io/rocs-2024-3705202/fr';
    window.open(collecteURL, '_blank');
  };

  const handleSave = async (event) => {
    try {
      event.preventDefault();
      const response = await axios.patch(
        `/equipe/modifyTeam`,
        { id: id, telephone: telephone },
        { headers: { Authorization: authHeader() } }
      );
      if (response.status === 201) {
        setErrMsg("Informations modifiées");
        setSeverity("success");
        setOpen(true);
      }
    } catch (error) {
      console.error("Erreur lors de la modification des infos de l'équipe:", error);
    }
  };

  const renderProfile = () => (
    <Box sx={{ mt: 10, width: '100%', ml: {lg:'10rem',xs:0}}}>
      <Typography variant="h4" sx={{ mb: 3, color: "black", fontWeight: 'bold' }}>Profil</Typography>      
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {equipes.map((equipe) => (
          <Box
            key={equipe.id}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              width: { xs: '100%', sm: '100%' },
              gap: '1rem'
            }}
          >
            
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
              <Typography variant="body1" sx={{ fontWeight: 'bold', minWidth: '150px' }}>Nom</Typography>
              <Typography sx={{ fontWeight: 'bold',backgroundColor: '#f4f4f4',py:'0.3rem',px:'1.5rem',borderRadius:'10px' }} variant="body1">{equipe.name}</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Typography variant="body1" sx={{ fontWeight: 'bold', minWidth: '150px' }}>Prénom</Typography>
              <Typography sx={{ fontWeight: 'bold',backgroundColor: '#f4f4f4',py:'0.3rem',px:'1.5rem',borderRadius:'10px' }} variant="body1">{equipe.firstname}</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Typography variant="body1" sx={{ fontWeight: 'bold', minWidth: '150px' }}>Téléphone</Typography>
              <Typography sx={{ fontWeight: 'bold',backgroundColor: '#f4f4f4',py:'0.3rem',px:'1.5rem',borderRadius:'10px' }} variant="body1">{equipe.phonenumber}</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Typography variant="body1" sx={{ fontWeight: 'bold', minWidth: '150px' }}>Email</Typography>
              <Typography sx={{ fontWeight: 'bold',backgroundColor: '#f4f4f4',py:'0.3rem',px:'1.5rem',borderRadius:'10px' }} variant="body1">{equipe.email}</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Typography variant="body1" sx={{ fontWeight: 'bold', minWidth: '150px' }}>Profil</Typography>
              <Typography sx={{ fontWeight: 'bold',backgroundColor: '#f4f4f4',py:'0.3rem',px:'1.5rem',borderRadius:'10px' }} variant="body1">{equipe.profile}</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Typography variant="body1" sx={{ fontWeight: 'bold', minWidth: '150px' }}>Pack</Typography>
              <Typography sx={{ fontWeight: 'bold',backgroundColor: '#f4f4f4',py:'0.5rem',px:'1rem',borderRadius:'8px' }} variant="body1">{equipe.pack}</Typography>
            </Box>
            {equipe.sport && (
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Typography variant="body1" sx={{ fontWeight: 'bold', minWidth: '150px' }}>Sport Matin</Typography>
              <Typography sx={{ fontWeight: 'bold',backgroundColor: '#f4f4f4',py:'0.3rem',px:'1.5rem',borderRadius:'10px' }} variant="body1">{equipe.sport}</Typography>
            </Box>)}
            {equipe.sport_2 && (
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Typography variant="body1" sx={{ fontWeight: 'bold', minWidth: '150px' }}>Sport Après-midi</Typography>
              <Typography sx={{ fontWeight: 'bold',backgroundColor: '#f4f4f4',py:'0.3rem',px:'1.5rem',borderRadius:'10px' }} variant="body1">{equipe.sport_2}</Typography>
            </Box>)}
          </Box>
        ))}
      </Box>
      <Box sx={{ mt: '2rem' }}>
          <Typography variant="body2" sx={{ mb: 2, color: 'red'}}>
              Pour toute modification de profil, veuillez envoyer un email à <strong>rocs@cs-sports.fr</strong>
          </Typography>      
        </Box>    
    </Box>
  );

  const renderPayment = () => (
    <Box sx={{ mt: 10, width: '100%', ml: {lg:'10rem',xs:0}}}>
      <Typography variant="h4" sx={{ mb: 2, color: "black", fontWeight: 'bold' }}>Paiement</Typography>      
      <Typography variant="h6" sx={{ color: payement === 1 ? 'green' : 'red', mb: 2 }}>
        Statut paiement : Votre participation est {payement === 1 ? 'payée' : 'non payée'}
      </Typography>
      <Button variant="contained" onClick={handlePayement} sx={{ backgroundColor: '#96013C' }}>
        Payer
      </Button>
    </Box>
  );

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: 'flex',width:'100%x' }}>
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <Navbarespaceperso />
        </Box>

        <Box sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          minHeight: '110vh',
          backgroundColor: 'white',
        }}>
          <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
            <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
              {errMsg}
            </Alert>
          </Snackbar>
          <Box sx={{ width: { xs: '100%', md: '20%' }, borderRight: { md: '2px solid #ddd' } }}>
            <Box sx={{ borderBottom: '2px solid #ddd', margin: { xs: '0 1rem', md: '2rem 0.5rem 0.5rem' },marginTop:{xs:'2rem'}, paddingBottom: '1.5rem', display: { sm: 'none', md: 'flex' }, flexDirection: { md: 'column' } }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '0.3rem' }}>Espace Personnel</Typography>
              <Typography variant='body2' sx={{ opacity: '0.7' }}> Gérez vos informations personnelles et paiements</Typography>
            </Box>
            <List component="nav" sx={{ display: 'flex', flexDirection: { xs: 'row', md: 'column' } }}>
              <ListItem
                button
                selected={activeSection === 'profile'}
                onClick={() => setActiveSection('profile')}
                sx={{
                  '&:hover': {
                    backgroundColor: '#f0f0f0',
                    borderRadius: '10px',
                    width: { xs: '100%', md: '90%' },
                  },
                  '&.Mui-selected': {
                    backgroundColor: '#f0f0f0',
                    borderRadius: '10px',
                    width: { xs: '100%', md: '90%' },
                  },
                  margin: { xs: '0', md: '0.3rem 5%' }
                }}
              >
                <ListItemIcon>
                  <PersonIcon />
                </ListItemIcon>
                <ListItemText primary="Mon Profil" />
              </ListItem>
              <ListItem
                button
                selected={activeSection === 'payment'}
                onClick={() => setActiveSection('payment')}
                sx={{
                  '&:hover': {
                    backgroundColor: '#f0f0f0',
                    borderRadius: '10px',
                    width: { xs: '100%', md: '90%' },
                  },
                  '&.Mui-selected': {
                    backgroundColor: '#f0f0f0',
                    borderRadius: '10px',
                    width: { xs: '100%', md: '90%' },
                  },
                  margin: { xs: '0', md: '0.3rem 5%' }
                }}
              >
                <ListItemIcon>
                  <PaymentIcon />
                </ListItemIcon>
                <ListItemText primary="Paiement" />
              </ListItem>
            </List>
          </Box>
          <Box sx={{ flexGrow: 1, p: 2 }}>
            {loading ? (
              <Typography variant="h4" sx={{ mt: 10, textAlign: "center" }}>Chargement...</Typography>
            ) : activeSection === 'profile' ? (
              renderProfile()
            ) : (
              renderPayment()
            )}
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default Espace_Perso;
